import { duration } from "@mui/material"

export const TABS = [
  { key: 1, label: "Quarterly" },
  { key: 2, label: "Half Yearly" },
  { key: 3, label: "Yearly" },
]

export const PLANS = [
  {
    id: "OY0240003",
    noOfMonths: 3,
    isPopular: false,
    prevPrice: "₹1760",
    price: 1600,
    planName: "Quarterly",
    planDescription:
      "Start your vision therapy journey with targeted exercises over an effective 3-month program.",
    planBenefits: [
      "100+ Exercises",
      "Premium AI based reporting and analytics",
      "VR integrations",
      "Access guide, comprehensive resources",
      "Priority chat and email support",
    ],
  },
  {
    id: "OY0240006",
    noOfMonths: 6,
    isPopular: true,
    prevPrice: "₹2200",
    price: 2000,
    off: "-10%",
    planName: "Half yearly",
    planDescription:
      "Strengthen visual skills and build consistency with our balanced and supportive 6-month plan.",
    planBenefits: [
      "100+ Exercises",
      "Premium reporting and analytics",
      "VR integrations",
      "Dedicated Doctor to consult for free",
      "Priority chat and email support",
    ],
  },
  {
    id: "OY0240012",
    isPopular: false,
    noOfMonths: 12,
    price: 2600,
    off: "-10%",
    planName: "Yearly",
    planDescription:
      "Experience full transformation in vision health with our most complete 12-month therapy package",
    planBenefits: [
      "100+ Exercises",
      "Premium reporting and analytics",
      "VR integrations",
      "Dedicated Doctor to consult for free",
      "Priority chat and email support",
    ],
  },
]
